import { useLayoutEffect } from "react";
import { useSetStyleEditorView } from "../../../hooks/style";

export function MapMarkers() {
  const setStyleEditorView = useSetStyleEditorView();

  useLayoutEffect(() => {
    setStyleEditorView("markers");
  }, [setStyleEditorView]);

  return null;
}
